// extracted by mini-css-extract-plugin
export default {"inputError":"inputerror_inputError__VB01u","alertIcon":"inputerror_alertIcon__3rg+-"};